(() => {
  const initialiseCredibilitySlider = (root = document) => {
    const viewports = [...(root.querySelectorAll?.('[data-credibility-viewport]') || [])];

    viewports.forEach((viewport) => {
      if (viewport.dataset.credibilityReady === 'true') return;
      const track = viewport.querySelector('[data-credibility-track]');
      if (!track) return;

      viewport.dataset.credibilityReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let loopWidth = 0;
      let position = viewport.scrollLeft;
      let lastTime = performance.now();
      let frame = null;
      let pausedUntil = 0;
      let hovering = false;
      let focused = false;
      let dragging = false;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragMoved = false;
      let suppressClick = false;
      let inView = false;

      const normaliseScroll = (value) => {
        if (!loopWidth) return Math.max(0, value);
        while (value < 0) value += loopWidth;
        while (value >= loopWidth) value -= loopWidth;
        return value;
      };

      const measureLoop = () => {
        const firstSet = track.querySelector('.pu-credibility__set');
        loopWidth = firstSet ? firstSet.getBoundingClientRect().width : track.scrollWidth / 2;
        position = normaliseScroll(viewport.scrollLeft);
      };

      const pause = (duration) => {
        pausedUntil = Math.max(pausedUntil, performance.now() + duration);
      };

      const runLoop = (now) => {
        if (!loopWidth) measureLoop();
        const elapsed = Math.min(now - lastTime, 64);
        lastTime = now;
        if (inView && !document.hidden && !reducedMotion && !dragging && !hovering && !focused && now >= pausedUntil) {
          position = normaliseScroll(position + elapsed * 0.022);
          viewport.scrollLeft = position;
        }
        frame = window.requestAnimationFrame(runLoop);
      };

      viewport.addEventListener('pointerdown', (event) => {
        pause(1800);
        if (event.pointerType === 'touch' || event.button !== 0) return;
        dragging = true;
        dragMoved = false;
        dragStartX = event.clientX;
        dragStartScroll = viewport.scrollLeft;
        position = dragStartScroll;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 5) dragMoved = true;
        position = normaliseScroll(dragStartScroll - distance);
        viewport.scrollLeft = position;
        event.preventDefault();
      });

      const endDrag = (event) => {
        if (dragging && dragMoved) {
          suppressClick = true;
          window.setTimeout(() => { suppressClick = false; }, 350);
        }
        dragging = false;
        viewport.classList.remove('is-dragging');
        pause(1400);
        if (event && viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      };

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('touchstart', () => { pause(2200); }, { passive: true });
      viewport.addEventListener('touchend', () => {
        position = viewport.scrollLeft;
        pause(1400);
      }, { passive: true });
      viewport.addEventListener('scroll', () => {
        if (dragging || performance.now() < pausedUntil) position = viewport.scrollLeft;
      }, { passive: true });
      viewport.addEventListener('mouseenter', () => { hovering = true; });
      viewport.addEventListener('mouseleave', () => { hovering = false; endDrag(); });
      viewport.addEventListener('focusin', () => { focused = true; });
      viewport.addEventListener('focusout', () => { focused = false; pause(800); });
      viewport.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
      viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        pause(1400);
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        position = normaliseScroll(viewport.scrollLeft + (direction * 180));
        viewport.scrollLeft = position;
      });

      measureLoop();
      window.addEventListener('resize', measureLoop);
      if ('IntersectionObserver' in window) {
        const visibility = new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
          if (inView && !frame) { lastTime = performance.now(); frame = requestAnimationFrame(runLoop); }
          if (!inView && frame) { cancelAnimationFrame(frame); frame = null; }
        });
        visibility.observe(viewport);
      } else { inView = true; frame = requestAnimationFrame(runLoop); }
    });
  };

  initialiseCredibilitySlider();
  document.addEventListener('shopify:section:load', (event) => initialiseCredibilitySlider(event.target));
})();
